import styled from "styled-components";
import { Link } from "@tvg/fuse-link";
import { gridConfig } from "@tvg/fuse-responsive-grid";

export const StyledLi = styled.li`
  flex: 0 0 auto;
  padding: 6px 0;

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    display: inline-block;
    padding: var(--spacing-space4) 0;
  }
`;

export const StyledBrand = styled(Link)`
  line-height: 20px;
  border-radius: 20px;
  padding: var(--spacing-space8) var(--spacing-space16);
  margin-right: var(--spacing-space8);
  color: var(--color-base-black, #000000);
  background: var(--grey-grey-200, #f6f6f6);
  border: 1px solid var(--Grey-grey-700, #878787);
  cursor: pointer;
`;
